import { Type } from '@angular/core';

/**
 * ## Widget Lazy Loader
 *
 * Loads the proposal-history widget chunk on demand for CRM opportunity detail view.
 * Helps keep initial opportunity screen bundle smaller.
 *
 * @returns Promise of lazy-loaded widget component type.
 */
export const loadCrmProposalHistoryWidgetComponent = (): Promise<Type<any>> =>
  import('./crm-proposal-history-widget.module').then(m => m.CrmProposalHistoryWidgetComponent);
